import OrticaMaps from "../class/OrticaMaps";
import style from "../style/common";

class OrticaMapV1 extends OrticaMaps {
	static mapVersion = "v1";

	constructor (configs) {
		super(configs);
	}

	static init (mapConfigs) {
		return new this(mapConfigs)
      .setMapControls({
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        mapTypeControl: false,
        zoomControl: false,
      })
      .setStyle(style)
      .renderMap()
      .setMarkers()
      .attachMarkersToMap()
      .centerMapByMarker()
      .attachSearchBar()
      .maybeHandleBasicPagination();
	}

	markup(location, i) {
		return `
			<div class="map__marker flex flex-wrap p-md border mb-sm" data-coordinate='${JSON.stringify(location.marker).replace(/'/g, "\\'")}'>
				<div class="w-full md:w-6/12 flex items-center">
					<img src="${this.markerImg.url}" alt="">
					${location.shop.name}
				</div>
				<div class="w-full md:w-6/12">
					${location.shop.address}
				</div>
			</div>`;
	}
}

OrticaMapV1.load()
.then(maps => OrticaMapV1.init(maps))
.catch(console.log);